var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"index-content"},[_c('u-page-back',{attrs:{"title":"购买页"}}),_c('iframe',{staticClass:"iframe-wrapper",attrs:{"scrolling":"auto","src":_vm.productsLink,"id":"sub_frame"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }